import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import PageRefundDetails from '@cashew/page-refand-details';

import { useSelector } from 'react-redux';
import ListTransactions from '../../components/ListTransactions';
import { BackArrow, PageWithNavigation, Title } from '../../components';
import RefundHistoryItem from '../../components/RefundHistoryItem';
import { UserState } from '../../reducers/user';
import { RootState } from '../../reducers';

/**
 * Orders Page RefundPage
 */
const ns = 'refund-details';

export default () => {
  const { t } = useTranslation();
  const history = useHistory();

  const { language }: UserState = useSelector((state: RootState) => state.user);
  const params: any = useParams();

  return (
    <div className={ns}>
      <Helmet>
        <title>Refund Details</title>
      </Helmet>
      <PageWithNavigation>
        <Title className={`${ns}__title`}>
          {`Refund ${params.refundId}`}
          <BackArrow to={`/${language}/refunds`} title="Back to refunds" />
        </Title>
        <PageRefundDetails
          ListTransactions={ListTransactions}
          RefundHistoryItem={RefundHistoryItem}
          type="admin"
          language={language}
          t={t}
          useSelector={useSelector}
          history={history}
          refundId={params.refundId}
        />
      </PageWithNavigation>
    </div>
  );
};
